import { render, staticRenderFns } from "./GameloftIcon.vue?vue&type=template&id=68007cef&"
import script from "./GameloftIcon.vue?vue&type=script&lang=js&"
export * from "./GameloftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports